import { render } from "./EditBlogs.vue?vue&type=template&id=78fc70da"
import script from "./EditBlogs.vue?vue&type=script&lang=js"
export * from "./EditBlogs.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__